import React from "react";
import { Skeleton } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleSkeletonProps extends React.ComponentProps<typeof Skeleton> {
  useEditorTheme?: boolean;
}

// Base themed component that handles the theme configuration
const ThemedComponent = ({ useEditorTheme, children, ...restProps }: TrebbleSkeletonProps & { children?: React.ReactNode }) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      {children}
    </TrebbleConfigProvider>
  );
};

// Main Skeleton component
const TrebbleSkeletonComponent = ({ useEditorTheme, ...restProps }: TrebbleSkeletonProps) => {
  return (
    <ThemedComponent useEditorTheme={useEditorTheme}>
      <Skeleton {...restProps} />
    </ThemedComponent>
  );
};

// Themed sub-components
const ThemedInput = ({ useEditorTheme, ...props }: any) => (
  <ThemedComponent useEditorTheme={useEditorTheme}>
    <Skeleton.Input {...props} />
  </ThemedComponent>
);

const ThemedButton = ({ useEditorTheme, ...props }: any) => (
  <ThemedComponent useEditorTheme={useEditorTheme}>
    <Skeleton.Button {...props} />
  </ThemedComponent>
);

const ThemedAvatar = ({ useEditorTheme, ...props }: any) => (
  <ThemedComponent useEditorTheme={useEditorTheme}>
    <Skeleton.Avatar {...props} />
  </ThemedComponent>
);

const ThemedNode = ({ useEditorTheme, ...props }: any) => (
  <ThemedComponent useEditorTheme={useEditorTheme}>
    <Skeleton.Node {...props} />
  </ThemedComponent>
);

const ThemedImage = ({ useEditorTheme, ...props }: any) => (
  <ThemedComponent useEditorTheme={useEditorTheme}>
    <Skeleton.Image {...props} />
  </ThemedComponent>
);

// Attach themed sub-components
TrebbleSkeletonComponent.Input = ThemedInput;
TrebbleSkeletonComponent.Button = ThemedButton;
TrebbleSkeletonComponent.Avatar = ThemedAvatar;
TrebbleSkeletonComponent.Node = ThemedNode;
TrebbleSkeletonComponent.Image = ThemedImage;

// Type assertion to inform TypeScript about the added static properties
const TrebbleSkeleton = TrebbleSkeletonComponent as typeof TrebbleSkeletonComponent & {
    Input: typeof Skeleton.Input;
    Button: typeof Skeleton.Button;
    Avatar: typeof Skeleton.Avatar;
    Node: typeof Skeleton.Node;
    Image: typeof Skeleton.Image;
};

export default TrebbleSkeleton; 